angular.module('property-deal')
    .component('propertyDealStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span ng-if="$ctrl.status != null" class="label label-default property-deal-status {{$ctrl.status}}">{{ 'property-deal.status.' + $ctrl.status | translate }}</span>
       `
    })
